/**
 * Convert a ratio (0–1) to a percentage (0–100).
 *
 * When `decimals` is provided the result is rounded to that many decimal places.
 * When omitted the raw multiplication result is returned (no rounding), preserving
 * backward compatibility with existing callers.
 *
 * @example ratioToPercent(0.75)     // 75
 * @example ratioToPercent(0.756, 0) // 76
 * @example ratioToPercent(0.7566, 2) // 75.66
 */
export function ratioToPercent(ratio: number, decimals?: number): number {
  const percent = ratio * 100;
  return decimals === undefined ? percent : Number(percent.toFixed(decimals));
}
